<div class="export-fields" [attr.data-automation-id]="automationId + '-container'">
    <div class="header-bar" [attr.data-automation-id]="automationId + '-header'">
        <button type="button" [attr.data-automation-id]="automationId + '-save-button'" class="primary-button"
            (click)="saveChanges()" [disabled]="!isDirty || isBusy" *ngIf="hasCreatePermissions">Save</button>
        <button type="button" [attr.data-automation-id]="automationId + '-discard-changes-button'"
            class="secondary-button" (click)="discardChanges()" [disabled]="!isDirty || isBusy"
            *ngIf="hasCreatePermissions">Discard Changes</button>
        <button type="button" data-automation-id="export-fields-reset-to-defaults-button" class="secondary-button"
            (click)="openResetToDefaultsModal()" [disabled]="false" *ngIf="hasCreatePermissions">
            <i class="fa fa-undo sizing-icons"></i>Reset to Defaults</button>
        <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
            (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>
    <form class="grids-container" #contentForm="ngForm" [attr.data-automation-id]="automationId + '-content'"
        [resBusySpinner]="isBusy" [message]="isBusyMessage">
        <div class="available-fields-section"
            data-automation-id="export-fields-modal-all-available-fields-section-container">
            <res-generic-grid [automationId]="'available-fields-grid'" [rowSelection]="availableFieldsSelection"
                [pagerVisible]="false" [columnDefs]="availableFieldsColumns" [gridContext]="availableFieldsGridContext"
                [headerTemplate]="availableFieldsTemplate" [onCustomFilterCallback]="onCustomFilterCallback"
                [hasCustomCellTemplates]="true" [rowClassRules]="rowDisabledAvailableFields">
            </res-generic-grid>
            <ng-template #availableFieldsTemplate>
                <div class='parent-header'>
                    <span>Available Fields</span>
                </div>
            </ng-template>
        </div>

        <div class="vertical-spacer"></div>

        <div class="export-fields-section" data-automation-id="export-fields-modal-export-fields-section-container">
            <div class='parent-header'>
                <span>Selected Export Fields</span>
                <div class="buttons" *ngIf="hasCreatePermissions">
                    <button type="button" data-automation-id="export-fields-new-group-field-button"
                        class="secondary-button" (click)="newGroupField()">
                        <i class="fa fa-plus sizing-icons"></i>New Transformed Field ...</button>
                </div>
                <div class='grid-row-delete' *ngIf="hasCreatePermissions">
                    <span (click)="moveUp()" class="moveUpClass" data-automation-id="export-fields-move-up-button"
                        [ngClass]="[moveUpEnabled() ? 'enabled-class' : 'disabled-class']">
                        <i class="fa fa-arrow-up"
                            [ngClass]="[moveUpEnabled() ? 'enabledArrow' : 'disabledArrow']"></i>Move
                        Up</span>
                    <span (click)="moveDown()" class="moveDownClass" data-automation-id="export-fields-move-down-button"
                        [ngClass]="[moveDownEnabled() ? 'enabled-class' : 'disabled-class']">
                        <i class="fa fa-arrow-down"
                            [ngClass]="[moveDownEnabled() ? 'enabledArrow' : 'disabledArrow']"></i>Move
                        Down</span>
                    <span (click)="deleteSelectedExportFields()"
                        [ngClass]="[selectedExportFields.length > 0 ? 'enabled-class' : 'disabled-class']"
                        data-automation-id="export-fields-delete-selected-button">
                        <i class="fa fa-trash sizing-icons"></i>Delete Selected</span>
                </div>
            </div>
            <div class="list-container">
                <div class="list-header">
                    <div class="checkbox-header" *ngIf="hasCreatePermissions">
                        <res-custom-checkbox [automationId]="automationId + '-grid-select-all'"
                            [isIndeterminate]="isPartiallySelected()" (click)="selectionChanged($event)"
                            [labelPaddingLeft]="21" [labelPaddingRight]="7">
                        </res-custom-checkbox>
                    </div>
                    <div class="header">
                        <span [attr.data-automation-id]="automationId + '-grid-header-cell-dr-field-name-label'">
                            DR Field Name
                        </span>
                    </div>
                    <div class="header">
                        <span [attr.data-automation-id]="automationId + '-grid-header-cell-export-field-name-label'">
                            Export Field Name
                        </span>
                    </div>
                </div>
                <div class="filter-container">
                    <div class="filter-none-box"
                        [attr.data-automation-id]="automationId + '-grid-header-cell-filter-none-box'"></div>
                    <div class="filter-input-field">
                        <res-filter #resFilterComponent
                            [attr.data-automation-id]="automationId + '-grid-header-cell-filter-input'"
                            [filterInputAutoId]="automationId + '-grid-header-cell-field-name'"
                            [clearButtonDataAutoId]="automationId + '-grid-header-cell-field-name'" [maxChars]=200
                            [placeholder]='"Filter by DR Field Name or Export Field Name..."'
                            [callback]="onFilterInput.bind(this)"></res-filter>
                    </div>
                </div>

                <cdk-virtual-scroll-viewport class="list-content" itemSize="55">
                    <div *cdkVirtualFor="let entry of exportFieldsSelectable; index as i; trackBy: trackByFn; templateCacheSize: 0"
                        (click)="selectionChanged($event, entry)"
                        [attr.data-automation-id]="'export-fields-list-item-' + i"
                        [ngStyle]="{'height' : entry.fieldsHeight && entry.fieldsHeight > 0 ? (entry.fieldsHeight + 'px') : '55px'}">
                        <div class="list-item-empty-drop-zone-holder" dndDropzone
                            (dndDrop)="onFieldDndDrop($event, entry)"
                            [dndDisableIf]="!hasCreatePermissions || filterValue !== ''">
                            <div class="list-item empty-drop-zone"
                                [attr.data-automation-id]="automationId + '-empty-drop-zone'">
                            </div>
                            <div class="list-item" draggable [dndDraggable]="entry"
                                [ngClass]="[entry.isSelected ? 'isSelected' : '', !hasCreatePermissions ? 'isDisabled' : '']">
                                <div class="row-container" [ngClass]="[!hasCreatePermissions ? 'isDisabled' : '']">
                                    <div class="checkbox-column" *ngIf="hasCreatePermissions">
                                        <img class="drag-dots" src="assets/images/drag_grey.png"
                                            data-automation-id="export-fields-grid-cell-drag-button">
                                        <res-custom-checkbox [automationId]="'export-fields-grid-cell-' + i"
                                            [(ngModel)]="entry.isSelected" name="entry.isSelected_{{i}}"
                                            [labelPaddingLeft]="10" [labelPaddingRight]="7" [notClickable]="true">
                                        </res-custom-checkbox>
                                    </div>
                                    <div class="field-name-column">
                                        <span [title]="entry.digitalReefMetadataValue" class="min-cell-height"
                                            [attr.data-automation-id]="'export-fields-list-item-drfieldname-' + i"
                                            [ngClass]="[!hasCreatePermissions ? 'disabled-text' : '']">{{entry.digitalReefMetadataValue}}
                                        </span>
                                    </div>
                                    <div *ngIf="entry.digitalReefMetadataValue !== 'TRANSFORMEDFIELD'"
                                        class="user-field min-cell-height">
                                        <input type="text" [(ngModel)]="entry.externalName"
                                            name="entry.externalName_{{i}}" [attr.maxlength]="maxNameLength"
                                            [attr-data-automation-id]="'export-fields-list-item-fieldname-textinput-' + i"
                                            (input)="externalNameChangedValue(entry)" (click)="onInputNameClicked($event)"
                                            [dndDisableDragIf]="'true'" [disabled]="!hasCreatePermissions">
                                    </div>
                                    <div class="group-field-name-column"
                                        *ngIf="entry.digitalReefMetadataValue === 'TRANSFORMEDFIELD'">
                                        <span [title]="entry.externalName" class="min-cell-height"
                                            [attr.maxlength]="maxNameLength"
                                            [attr.data-automation-id]="'export-fields-list-item-drfieldname-' + i"
                                            [ngClass]="[!hasCreatePermissions ? 'disabled-text' : '']">{{entry.externalName}}</span>
                                        <i class="fa fa-pencil" (click)="openEditGroupFieldModal($event, entry)"
                                            *ngIf="hasCreatePermissions"></i>
                                    </div>
                                </div>
                                <div class="group-row" *ngIf="entry.fields && entry.fields.length > 0">
                                    <div class="group-field-row"
                                        *ngFor='let field of entry.fields; index as ind; trackBy: trackByFieldRow;'>
                                        <div class="input-style"
                                            [ngStyle]="{'padding-bottom' : ind === entry.fields.length - 1 ? '10px' : '0px'}">
                                            <p [ngClass]="[!hasCreatePermissions ? 'disabled-input-style' : '']">
                                                {{field}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="empty-export-fields empty-drop-zone"
                        [attr.data-automation-id]="automationId + '-empty-drop-zone'" dndDropzone
                        (dndDrop)="onEmptyDropZone($event)" *ngIf="hasCreatePermissions">
                        <span>Drop field(s) to map here ...</span>
                    </div>
                </cdk-virtual-scroll-viewport>
            </div>
        </div>
        <a download #downloadLink hidden target="_blank"></a>
    </form>
</div>